/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'ico-fb': {
    width: 10,
    height: 18,
    viewBox: '0 0 10 18',
    data: `<path pid="0" d="M9.95 5.828H6.885V3.96c0-.701.5-.865.853-.865H9.9V.011L6.92 0C3.616 0 2.863 2.3 2.863 3.773v2.055H.95v3.179h1.912V18h4.023V9.007h2.714l.351-3.179z"/>`
  }
})
